import { Routes } from '@angular/router';
import { AnzCampaignPageVariant1Component } from '../views/campaign-page-variant1/campaign-page-variant1.component';
import { AnzCampaignPageComponent } from '../views/campaign-page/campaign-page.component';

export const anzCampaignPageRoutes: Routes = [
  {
    path: 'cathay',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'cxasiamiles',
    },
  },
  {
    path: 'vavelocityfrequentflyer',
    component: AnzCampaignPageComponent,
    data: {
      partnerId: 'vavelocityfrequentflyer',
    },
  },
  {
    path: 'terms',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'amazonapple',
    },
  },
  {
    path: 'myer',
    component: AnzCampaignPageComponent,
    data: {
      partnerId: 'myer',
    },
  },
  {
    path: 'westfield',
    component: AnzCampaignPageComponent,
    data: {
      partnerId: 'westfield',
    },
  },
  {
    path: 'merchandise',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'merchandise',
    },
  },
  {
    path: 'myerwestfield',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'myerwestfield',
    },
  },
  {
    path: 'giftcards',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'giftcards',
    },
  },
  {
    path: 'pointstransfer',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'pointstransfer',
    },
  },
  {
    path: 'MAY2310OFF',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'may2310off',
    },
  },
  {
    path: 'upto25',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'upto25',
    },
  },
  {
    path: 'velocitybonus',
    component: AnzCampaignPageVariant1Component,
    data: {
      partnerId: 'velocitybonus',
    },
  },
];
